// Who a company's job or RFP is open to. Each posting stores one of three values in
// `publicData.visibility`; the company's own default is stored on its listing as
// `publicData.onBoardingInfo.jobRfpVisibility`. Older records hold other spellings of the same three
// choices, so every reader goes through `visibilityOf`, which maps each of them, and anything it does
// not know, to one of the three.
//
// Written as plain CommonJS with no imports so the API server, which runs its files under plain
// node, can require this same file the browser bundle imports.

const VISIBILITY = Object.freeze({
  OPEN: 'open',
  SUPPLIERS: 'preferredSuppliers',
  CONSULTANTS: 'preferredConsultants',
});

const VISIBILITY_VALUES = Object.freeze([VISIBILITY.OPEN, VISIBILITY.SUPPLIERS, VISIBILITY.CONSULTANTS]);

const POSTING_TYPES = Object.freeze(['job_listing', 'rfp_listing']);

// Every stored spelling of a restricted choice. Anything else, including nothing at all, is open.
const RESTRICTED_SPELLINGS = Object.freeze({
  'Preferred Vendors': VISIBILITY.SUPPLIERS,
  preferredVendors: VISIBILITY.SUPPLIERS,
  preferredSuppliers: VISIBILITY.SUPPLIERS,
  'Preferred Consultants': VISIBILITY.CONSULTANTS,
  preferredConsultants: VISIBILITY.CONSULTANTS,
});

/** One of the three values, from any stored spelling. */
const visibilityOf = value =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(RESTRICTED_SPELLINGS, value.trim())
    ? RESTRICTED_SPELLINGS[value.trim()]
    : VISIBILITY.OPEN;

/** The value a save names, when it is exactly one of the three; null otherwise. */
const parseVisibility = value => (VISIBILITY_VALUES.includes(value) ? value : null);

/** Whether a listing's public data is a job's or an RFP's. */
const isPostingData = publicData => !!publicData && POSTING_TYPES.includes(publicData.listingType);

/** Whether a listing's public data is a job's or an RFP's that is not open to everyone. */
const isRestrictedPosting = publicData =>
  isPostingData(publicData) && visibilityOf(publicData.visibility) !== VISIBILITY.OPEN;

module.exports = {
  VISIBILITY,
  VISIBILITY_VALUES,
  POSTING_TYPES,
  visibilityOf,
  parseVisibility,
  isPostingData,
  isRestrictedPosting,
};
